// ==============================|| OVERRIDES - INPUT BASE ||============================== //

export default function InputBase(theme) {
  return {
    MuiInputBase: {
      styleOverrides: {
        sizeSmall: {
          fontSize: '0.75rem',
        },
        root: {
          '& .Mui-disabled': {
            color: theme.palette.text.secondary,
            WebkitTextFillColor: theme.palette.text.secondary,
            '&.MuiIconButton-root': {
              color: theme.palette.text.secondary,
            },
          },
          '&::placeholder': {
            textOverflow: 'ellipsis !important',
            color: theme.palette.text.secondary,
          },
          '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
        },
      },
    },
  }
}
